export const STANDARD_PACKAGING = 'StandardPackaging';
//# sourceMappingURL=standard-packaging.js.map